import type { InspectorConfig } from '@/api/installation.api';

/**
 * Avisos de la pestaña Inspector, en lenguaje llano.
 *
 * Hallazgo del recorrido con navegador: se podía encender el switch maestro con
 * TODO vacío y la pantalla no decía nada. El Inspector quedaba "encendido" pero
 * inerte, y el dueño creía haber configurado algo que no hacía nada.
 *
 * Son INFORMATIVOS, nunca bloquean: se puede querer encenderlo a medio llenar.
 * PURO: sin estado ni red.
 */
export function inspectorWarnings(cfg: InspectorConfig): string[] {
  const avisos: string[] = [];

  // Filas a medio llenar: importan SIEMPRE, porque se pierden al guardar.
  const textosVacios = cfg.indicadores.filter((i) => !i.texto.trim()).length;
  if (textosVacios > 0) {
    avisos.push(
      textosVacios === 1
        ? 'Hay un texto de publicidad sin escribir: si guardas así, esa fila se pierde.'
        : `Hay ${textosVacios} textos de publicidad sin escribir: si guardas así, esas filas se pierden.`,
    );
  }
  const tiposSinNombre = cfg.tiposCaso.filter((t) => !t.nombre.trim()).length;
  if (tiposSinNombre > 0) {
    avisos.push(
      tiposSinNombre === 1
        ? 'Hay un tipo de caso sin nombre: si guardas así, esa fila se pierde.'
        : `Hay ${tiposSinNombre} tipos de caso sin nombre: si guardas así, esas filas se pierden.`,
    );
  }

  // El resto solo aplica con el Inspector encendido.
  if (!cfg.activo) return avisos;

  const hayIndicadorUtil = cfg.indicadores.some((i) => i.activo && i.texto.trim());
  const hayInstrucciones = Boolean(cfg.prompt.trim());

  if (!hayIndicadorUtil && !hayInstrucciones) {
    avisos.push(
      'Está encendido pero no va a bloquear a nadie: no cargaste textos de publicidad ni ' +
        'instrucciones, así que todas las conversaciones caen en la opción de más abajo.',
    );
  } else if (cfg.capas.intencion && !hayInstrucciones) {
    avisos.push(
      'El paso 4 está encendido pero no escribiste las instrucciones del Inspector: ese paso ' +
        'no se va a usar.',
    );
  }

  if (cfg.noElegible.enviarCortesia && !cfg.cortesia.texto.trim()) {
    avisos.push(
      'Está activado mandar cortesía al cliente, pero el mensaje está vacío: no sale nada.',
    );
  }

  if (cfg.noElegible.notificarDestinatario) {
    if (!cfg.avisoDestinatario.trim()) {
      avisos.push(
        'Está activado avisarle a una persona, pero el texto del aviso está vacío: no sale nada.',
      );
    }
    if (!cfg.tiposCaso.some((t) => t.numeroIds.length > 0)) {
      avisos.push(
        'Ningún tipo de caso tiene destinatarios marcados: el aviso no le llegaría a nadie.',
      );
    }
  }

  return avisos;
}
